var map = {
	"./Zington_Logotyp_Pos_RGB.svg": 22,
	"./board.png": 23,
	"./compass.svg": 24,
	"./darkblue-arrow-right.svg": 25,
	"./elephant.png": 26,
	"./favicon.ico": 27,
	"./house.png": 28,
	"./network.png": 29,
	"./white-arrow-right.svg": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;